import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const FormField = ({ id, label, value, onChange, placeholder, required, multiline }) => (
  <div className="space-y-2">
    <Label htmlFor={id} className="text-slate-300">{label}</Label>
    {multiline ? (
      <Textarea
        id={id}
        data-testid={`article-${id}-input`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500 min-h-[120px]"
        required={required}
      />
    ) : (
      <Input
        id={id}
        data-testid={`article-${id}-input`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500"
        required={required}
      />
    )}
  </div>
);

export default FormField;
